<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [parkourBackButton]="['../../../']" />
    </ion-buttons>

    <ion-title>{{ 'team.geblokkeerd-team.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <parkour-page-gradient />
    <parkour-page-image
      classes="absolute top-0 left-0 z-0"
      src="/assets/team/background/background_team_blur.jpg"
    />
    <div
      *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data"
      class="relative z-10 flex flex-col py-8 container container-space gap-y-8"
    >
      <parkour-hero [image]="teamHeroSources">
        <div class="flex flex-col items-center text-center gap-y-4 container-1-col">
          <h1>{{ 'team.geblokkeerd-team.title' | translate }}</h1>

          <parkour-divider />
        </div>
      </parkour-hero>

      <parkour-info-card class="block container-1-col">
        <p>{{ 'team.geblokkeerd-team.info' | translate }}</p>
      </parkour-info-card>

      <parkour-profiel-block [profielData]="data.jongere" class="block container-1-col mb-6" />
      <parkour-team-verlaten-section
        [jongere]="data.jongere"
        [teamlidProfielId]="data.user.profielId"
        class="block container-1-col"
      />
    </div>
  </parkour-page-layout>
</ion-content>
